module.exports = __webpack_public_path__ + "img/funpoint.92badc4f.jpeg";